import { motion } from "framer-motion";

const fadeUp = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-60px" },
  transition: { duration: 0.7 },
};

export default function Problem() {
  return (
    <section data-testid="home-problem" className="py-24 md:py-32 border-b border-line">
      <div className="max-w-7xl mx-auto px-4 md:px-8 grid lg:grid-cols-12 gap-12">
        <motion.div {...fadeUp} className="lg:col-span-6">
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-ochre mb-6">The problem</p>
          <h2 className="font-serif text-3xl md:text-5xl tracking-tight leading-tight">
            Governance and authority can become <em className="text-ember">fragmented, obscured or displaced</em> across institutional systems.
          </h2>
        </motion.div>
        <motion.div {...fadeUp} transition={{ duration: 0.7, delay: 0.1 }} className="lg:col-span-6 flex flex-col justify-end">
          <p className="text-stone2 leading-relaxed max-w-xl mb-6">
            Records, policies, datasets and digital systems frequently carry
            decisions about First Nations peoples without carrying the
            authority behind them. Institutions hold the information — but
            often cannot answer who decides, who must be asked, and who
            carries the consequences.
          </p>
          <p className="text-bone border-l-2 border-ember pl-5 max-w-xl">
            Bigibila has developed a methodology to examine exactly that.
          </p>
        </motion.div>
      </div>
    </section>
  );
}
